import React from "react";
import moment from "moment";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Label,
  FormGroup,
} from "reactstrap";
import {
  Upload,
  Icon,
  message,
  notification,
  Select,
  Button,
  Input as In,
} from "antd";
import firebase from "../../../Firebase.js";
import {
  normalizeFiles,
  haySubidaEnCurso,
  urlDeItem,
  aFileList,
  aCampos,
} from "../../../utils/fileList";
import { propagarArchivosDeOp } from "services";

const { Option } = Select;

class NewDdpRecord extends React.Component {
  constructor() {
    super();
    this.ref = firebase.firestore().collection("ing");
    this.storageRef = firebase.storage();

    this.state = {
      fechaIngreso: new Date(),
      fechaIngresoDdp: new Date(),
      op: [""],
      isOpen: false,
      imgHC: null,
      selectedOption: null,
      ing: [],
      imgFT: null,
      label: null,
      value: null,
      ft: null,
      hc: null,
      lastIndexTelas: null,
      isActive: false,
      selectedFile: null,
      selectedFileList: [],
      filelistFT: null,
      filelistHC: [],
      filelistMoldes: [],
      filelistTizado: [],
      uploading: false,
      urlFT: [],
      fichTec: [],
      hojaCon: [],
      moldesList: [],
    };
    this.changeHc = this.changeHc.bind(this);
    this.changeFt = this.changeFt.bind(this);
    this.changeMoldes = this.changeMoldes.bind(this);
  }

  componentDidMount() {
    this.ref
      .orderBy("order", "desc")
      .get()
      .then((querySnapshot) => {
        let op_list = [];
        querySnapshot.forEach(function(doc) {
          op_list.push({ value: doc.id, label: doc.data().op });
        });
        let op = [];
        op_list.forEach((item, val) => {
          op.push({
            value: item.value,
            label: item.label,
          });
          this.setState({ op });
        });
      });

    firebase
      .firestore()
      .collection("ddp")
      .orderBy("order", "desc")
      .get()
      .then((query) => {
        const ftecnica = [];
        const hconsumo = [];
        const moldesArr = [];
        let urlFT = null;
        query.forEach((doc) => {
          if (doc.data().fichaTecnica) {
            ftecnica.push(doc.data().fichaTecnica);
          }
          if (doc.data().hojaConsumo) {
            hconsumo.push(doc.data().hojaConsumo);
          }
          if (doc.data().moldes) {
            moldesArr.push(doc.data().moldes);
          }
          urlFT = doc.data().b[null];
        });
        this.setState({
          urlFT: urlFT,
          fichTec: ftecnica,
          hojaCon: hconsumo,
          moldesList: moldesArr,
        });
      });
  }

  selectHandleChange = async (selectedOption) => {
    this.setState({ selectedOption });
    try {
      const doc = await this.ref.doc(String(selectedOption)).get();
      const data = doc.data() || {};
      this.setState({
        filelistHC: aFileList(normalizeFiles(data.hc, data.hojaConsumo)),
        filelistMoldes: aFileList(normalizeFiles(data.moldesUrl, data.moldes)),
        filelistTizado: aFileList(
          normalizeFiles(data.tizadoDdpUrl, data.tizadoDdp)
        ),
      });
    } catch (e) {
      console.log(e.message);
    }
  };

  handleClickShowAlert() {
    this.setState({
      isOpen: true,
    });

    setTimeout(() => {
      this.setState({
        isOpen: false,
      });
    }, 1000);
  }

  handleChange = (date) => {
    this.setState({
      fechaIngreso: date,
    });
  };

  handleChangeIngresoDDP = (date) => {
    this.setState({
      fechaIngresoDdp: date,
    });
  };

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };
  np;

  changeFt = (e) => {
    if (e.target.files[0]) {
      const imgFT = e.target.files[0];
      this.setState(() => ({ imgFT, ft: imgFT.name.slice(0, -4) }));
    }
  };

  changeHc = (e) => {
    if (e.target.files[0]) {
      const imgHC = e.target.files[0];
      this.setState(() => ({ imgHC, hc: imgHC.name.slice(0, -4) }));
    }
  };

  changeMoldes = (e) => {
    if (e.target.files[0]) {
      const imgMoldes = e.target.files[0];
      this.setState(() => ({ imgMoldes, moldes: imgMoldes.name.replace(/\.[^/.]+$/, "") }));
    }
  };

  handleChangeFT = (info) => {
    let fileListFT = [...info.fileList];

    fileListFT = fileListFT.slice(-1);

    fileListFT = fileListFT.map((file) => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });
    this.setState({ filelistFT: info.fileList, fileListFT });

    if (info.file.status === "uploding") {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === "done") {
      this.setState({ loading: false });
    }
  };

  customUploadFT = async ({ onError, onSuccess, file }) => {
    this.setState({ uploading: true });
    const metadata = {
      contentType: ".pdf",
    };
    const storager = await this.storageRef.ref();
    const pdfFile = storager.child(`fichaTecnica/${file.name}`);

    try {
      const pdf = await pdfFile.put(file, metadata);
      const url = await this.storageRef
        .ref("fichaTecnica")
        .child(file.name)
        .getDownloadURL();
      this.setState(() => ({
        file,
        ft: file.name.slice(0, -4),
        uploading: false,
      }));
      onSuccess(null, { ...pdf, url });
    } catch (e) {
      this.setState({ uploading: false });
      onError(e.message);
    }
  };

  handleChangeHC = (info) => {
    this.setState({ filelistHC: info.fileList });
    this.setState({ loading: info.file.status === "uploading" });
  };

  customUploadHC = async ({ onError, onSuccess, file }) => {
    this.setState({ uploading: true });
    const storager = await this.storageRef.ref();
    const nombre = `${Date.now()}-${file.name}`;

    try {
      const pdf = await storager.child(`hojaConsumo/${nombre}`).put(file);
      const url = await this.storageRef
        .ref("hojaConsumo")
        .child(nombre)
        .getDownloadURL();
      this.setState({ uploading: false });
      onSuccess(null, { ...pdf, url });
    } catch (e) {
      this.setState({ uploading: false });
      onError(e.message);
    }
  };

  handleChangeMoldes = (info) => {
    this.setState({ filelistMoldes: info.fileList });
    this.setState({ loading: info.file.status === "uploading" });
  };

  customUploadMoldes = async ({ onError, onSuccess, file }) => {
    this.setState({ uploading: true });
    const storager = await this.storageRef.ref();
    const nombre = `${Date.now()}-${file.name}`;

    try {
      const pdf = await storager.child(`moldes/${nombre}`).put(file);
      const url = await this.storageRef
        .ref("moldes")
        .child(nombre)
        .getDownloadURL();
      this.setState({ uploading: false });
      onSuccess(null, { ...pdf, url });
    } catch (e) {
      this.setState({ uploading: false });
      onError(e.message);
    }
  };

  handleChangeTizado = (info) => {
    this.setState({ filelistTizado: info.fileList });
    this.setState({ loading: info.file.status === "uploading" });
  };

  customUploadTizado = async ({ onError, onSuccess, file }) => {
    this.setState({ uploading: true });
    const storager = await this.storageRef.ref();
    const nombre = `${Date.now()}-${file.name}`;

    try {
      const pdf = await storager.child(`tizadosDdp/${nombre}`).put(file);
      const url = await this.storageRef
        .ref("tizadosDdp")
        .child(nombre)
        .getDownloadURL();
      this.setState({ uploading: false });
      onSuccess(null, { ...pdf, url });
    } catch (e) {
      this.setState({ uploading: false });
      onError(e.message);
    }
  };

  onSubmit = async (e) => {
    e.preventDefault();

    const {
      fechaIngreso,
      fechaIngresoDdp,
      selectedOption,
      op,
      ft,
      urlFT,
    } = this.state;

    this.setState({
      isActive: true,
    });

    const fIngreso = moment(fechaIngreso).format("DD/MM/YYYY");
    const fIngresoDdp = moment(fechaIngresoDdp).format("DD/MM/YYYY");

    const fichaTecnicaUrl =
      (this.state.filelistFT && this.state.filelistFT.length
        ? urlDeItem(this.state.filelistFT[0])
        : null) || urlFT;

    const hcFiles = aCampos(this.state.filelistHC);
    const moldesFiles = aCampos(this.state.filelistMoldes);
    const tizadoFiles = aCampos(this.state.filelistTizado);
    const hc = hcFiles.map((f) => f.name).join(", ");
    const moldes = moldesFiles.map((f) => f.name).join(", ");
    const tizado = tizadoFiles.map((f) => f.name).join(", ");

    const opSelected = op.filter((item) => item.value === selectedOption);
    const opName = opSelected[0].label;
    message.loading("Registrando...", 60);
    try {
      this.ref
        .doc(String(selectedOption))
        .get()
        .then((res) => {
          let ing_data = res.data();
          ing_data["fechaIngresoDdp"] = fIngresoDdp || "";
          
          if (ft) {
            ing_data.b = [fichaTecnicaUrl || ""];
            ing_data["fichaTecnica"] = ft || "";
          }
          // Se escriben siempre: la lista precargada refleja el conjunto
          // completo, asi que quitar el ultimo archivo debe dejar el campo vacio.
          ing_data.hc = hcFiles;
          ing_data["hojaConsumo"] = hc;
          ing_data.moldesUrl = moldesFiles;
          ing_data["moldes"] = moldes;
          ing_data.tizadoDdpUrl = tizadoFiles;
          ing_data["tizadoDdp"] = tizado;

          try {
            this.ref
              .doc(String(selectedOption))
              .set(ing_data, { merge: true })
              .then((docRef) => {
                this.setState({
                  ft: "",
                  filelistHC: [],
                  filelistMoldes: [],
                  filelistTizado: [],
                  selectedOption: "",
                });
                this.handleClickShowAlert();
                this.componentDidMount();
              });
          } catch (error) {
            console.error("Error adding document: ", error);
          }

          try {
            firebase
              .firestore()
              .collection("comercial")
              .where("op", "==", opName)
              .get()
              .then((querySnapshot) => {
                let comercialDocId = null;
                querySnapshot.forEach((doc) => {
                  comercialDocId = doc.id;
                });
                const data = {
                  cFechaIngreso: fIngreso || "",
                  fichaTecnica: ft || "",
                  f: [fichaTecnicaUrl || ""],
                };

                try {
                  firebase
                    .firestore()
                    .collection("comercial")
                    .doc(comercialDocId)
                    .update(data);
                } catch (e) {
                  console.log(e);
                }
              });
          } catch (error) {
            console.log(error.message);
          }

          try {
            firebase
              .firestore()
              .collection("ddp")
              .where("op", "==", opName)
              .get()
              .then((querySnapshot) => {
                let ddpDocId = null;
                querySnapshot.forEach((doc) => {
                  ddpDocId = doc.id;
                });
                // hojaConsumo/hc/moldes/moldesUrl los escribe
                // propagarArchivosDeOp; aqui solo ficha tecnica y estado.
                const data = {
                  fechaIngresoDdp: fIngresoDdp,
                  fichaTecnica: ft || "",
                  b: [fichaTecnicaUrl || ""],
                  estado: [
                    fichaTecnicaUrl && hcFiles.length ? "Listo" : "En curso",
                    opName,
                  ],
                };
                try {
                  firebase
                    .firestore()
                    .collection("ddp")
                    .doc(ddpDocId)
                    .update(data);
                } catch (e) {
                  console.log(e);
                }
              });
          } catch (e) {
            console.log(e);
          }

          try {
            firebase
              .firestore()
              .collection("telas")
              .where("op", "==", opName)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  // Sin spread de doc.data(): update() con campos explicitos
                  // evita revertir lo que escribe propagarArchivosDeOp.
                  const telaData = {
                    ft: ft || "",
                    b: fichaTecnicaUrl ? [fichaTecnicaUrl] : [],
                  };
                  firebase
                    .firestore()
                    .collection("telas")
                    .doc(doc.id)
                    .update(telaData);
                });
              });
          } catch (error) {
            console.log(error.message);
          }

          try {
            firebase
              .firestore()
              .collection("corte")
              .where("op", "==", opName)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  // Sin spread, por la misma razon que en telas.
                  const corteData = {
                    ft: ft || "",
                    b: fichaTecnicaUrl ? [fichaTecnicaUrl] : [],
                  };
                  firebase
                    .firestore()
                    .collection("corte")
                    .doc(doc.id)
                    .update(corteData);
                });
              });
          } catch (error) {
            console.log(error.message);
          }

          try {
            firebase
              .firestore()
              .collection("costura")
              .where("op", "==", opName)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  const costuraData = {
                    ...doc.data(),
                    ft: ft || "",
                    b: fichaTecnicaUrl ? [fichaTecnicaUrl] : [],
                  };
                  firebase
                    .firestore()
                    .collection("costura")
                    .doc(doc.id)
                    .update(costuraData);
                });
              });
          } catch (error) {
            console.log(error.message);
          }

          try {
            firebase
              .firestore()
              .collection("acabados")
              .where("op", "==", opName)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  const acabadosData = {
                    ...doc.data(),
                    ft: ft || "",
                    b: fichaTecnicaUrl ? [fichaTecnicaUrl] : [],
                  };
                  firebase
                    .firestore()
                    .collection("acabados")
                    .doc(doc.id)
                    .update(acabadosData);
                });
              });
          } catch (error) {
            console.log(error.message);
          }

          try {
            firebase
              .firestore()
              .collection("almacen")
              .where("op", "==", opName)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  const almacenData = {
                    ...doc.data(),
                    ft: ft || "",
                    b: fichaTecnicaUrl ? [fichaTecnicaUrl] : [],
                  };
                  firebase
                    .firestore()
                    .collection("almacen")
                    .doc(doc.id)
                    .update(almacenData);
                });
              });
          } catch (error) {
            console.log(error.message);
          }

          try {
            this.ref
              .doc(String(selectedOption))
              .update(ing_data)
              .then(() =>
                // El catch de abajo cubre toda la cadena; sin esto, un fallo
                // del update anterior se reportaria como fallo de propagacion.
                propagarArchivosDeOp(opName, {
                  hojaConsumo: hc,
                  hc: hcFiles,
                  moldes,
                  moldesUrl: moldesFiles,
                  tizadoDdp: tizado,
                  tizadoDdpUrl: tizadoFiles,
                }).catch((e) => {
                  throw new Error(`No se pudo propagar los archivos: ${e.message}`);
                })
              )
              .then(() => {
                message.destroy();
                const args = {
                  message: "Registro agregado existosamente.",
                  top: 80,
                };
                notification.success(args);
                this.setState({
                  isActive: false,
                });
                this.props.history.push("/Ddp/Procesos");
              })
              .catch((error) => {
                message.destroy();
                notification.error({ message: error.message, top: 80 });
                this.setState({ isActive: false });
              });
          } catch (error) {
            console.error("Error adding document: ", error);
          }
        });
    } catch (error) {
      alert("Sucedio un error. Ingrese nuevamente el registro", error);
      console.log(error.message);
      console.log(error);
    }
  };

  render() {
    const { ft, selectedOption, loading } = this.state;

    const tiene = (lista) => Boolean(lista && lista.length);
    const subiendo =
      this.state.uploading ||
      haySubidaEnCurso(
        this.state.filelistFT,
        this.state.filelistHC,
        this.state.filelistMoldes,
        this.state.filelistTizado
      );
    const isInvalid =
      !selectedOption ||
      !(
        ft ||
        tiene(this.state.filelistHC) ||
        tiene(this.state.filelistMoldes) ||
        tiene(this.state.filelistTizado)
      );

    const uploadButton = (
      <div>
        <Button
          style={{ display: "block", textAlign: "left", marginLeft: "15px" }}
        >
          <Icon type={loading ? "loading" : "plus"} />
          Seleccionar Archivo
        </Button>
      </div>
    );
    return (
      <div className="content">
        <Row>
          <Col md={12} xs={12}>
            <Card className="card-user">
              <CardHeader>
                <CardTitle style={{ marginLeft: "15px", textAlign: "center" }}>
                  REGISTRO DDP
                </CardTitle>
              </CardHeader>
              <CardBody>
                <form onSubmit={this.onSubmit}>
                  <FormGroup className="ml-3 mt-3">
                    <Label className="font-weight-bold">
                      ORDEN DE PRODUCCION
                    </Label>
                    <Select
                      showSearch={true}
                      className="col-md-3 d-block"
                      value={selectedOption}
                      onChange={this.selectHandleChange}
                      placeholder="Eliga Orden de produccion"
                    >
                      {this.state.op.map((item, index) => (
                        <Option key={index} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </FormGroup>
                  <Row>
                    <Label
                      style={{ marginLeft: "30px" }}
                      className="font-weight-bold"
                      for="ft"
                    >
                      FICHA TECNICA
                    </Label>
                  </Row>
                  <In
                    name="ft"
                    className="col-md-3 pr-1 ml-3"
                    value={ft}
                    onChange={this.onChange}
                    autoComplete="off"
                  />

                  <Row>
                    <Label
                      style={{ marginLeft: "30px", fontWeight: "bold" }}
                      className="mt-3"
                    >
                      FICHA TECNICA
                    </Label>
                  </Row>
                  <Upload
                    onRemove={() => this.setState({ filelistFT: null, ft: "" })}
                    accept={".pdf"}
                    multiple={false}
                    onChange={this.handleChangeFT}
                    customRequest={this.customUploadFT}
                    fileList={this.state.fileListFT}
                    style={{ display: "block", textAlign: "left" }}
                  >
                    {uploadButton}
                  </Upload>

                  <Row>
                    <Label
                      className="mt-4"
                      style={{ marginLeft: "30px", fontWeight: "bold" }}
                    >
                      HOJA DE CONSUMO
                    </Label>
                  </Row>
                  <Upload
                    onRemove={(file) =>
                      this.setState((prev) => ({
                        filelistHC: (prev.filelistHC || []).filter(
                          (f) => f.uid !== file.uid
                        ),
                      }))
                    }
                    accept={".pdf"}
                    multiple
                    onChange={this.handleChangeHC}
                    customRequest={this.customUploadHC}
                    fileList={this.state.filelistHC}
                    style={{ display: "block", textAlign: "left" }}
                  >
                    {uploadButton}
                  </Upload>

                  <Row>
                    <Label
                      className="mt-4"
                      style={{ marginLeft: "30px", fontWeight: "bold" }}
                    >
                      MOLDES
                    </Label>
                  </Row>
                  <Upload
                    onRemove={(file) =>
                      this.setState((prev) => ({
                        filelistMoldes: (prev.filelistMoldes || []).filter(
                          (f) => f.uid !== file.uid
                        ),
                      }))
                    }
                    multiple
                    onChange={this.handleChangeMoldes}
                    customRequest={this.customUploadMoldes}
                    fileList={this.state.filelistMoldes}
                    style={{ display: "block", textAlign: "left" }}
                  >
                    {uploadButton}
                  </Upload>

                  <Row>
                    <Label
                      className="mt-4"
                      style={{ marginLeft: "30px", fontWeight: "bold" }}
                    >
                      TIZADO DDP
                    </Label>
                  </Row>
                  <Upload
                    onRemove={(file) =>
                      this.setState((prev) => ({
                        filelistTizado: (prev.filelistTizado || []).filter(
                          (f) => f.uid !== file.uid
                        ),
                      }))
                    }
                    multiple
                    onChange={this.handleChangeTizado}
                    customRequest={this.customUploadTizado}
                    fileList={this.state.filelistTizado}
                    style={{ display: "block", textAlign: "left" }}
                  >
                    {uploadButton}
                  </Upload>

                  <Row>
                    <div className="update ml-auto mr-auto">
                      <Button
                        onClick={this.onSubmit}
                        type="primary"
                        style={{ marginnTop: "20px" }}
                        round
                        disabled={
                          this.state.isActive ||
                          subiendo ||
                          isInvalid
                        }
                      >
                        REGISTRAR
                      </Button>
                    </div>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default NewDdpRecord;
